const REGEX = Object.freeze({
  parenthesis: new RegExp(/^\(.*\)$/),
  quotes: new RegExp(/^".*"$/),
  singleTerm: /[+-]?[a-zA-Z'0-9]+|"[^"]+"/g,
});

function _getSplitTerms(text) {
  return text.match(REGEX.singleTerm);
}

function _shouldKeepIntactTerm(text) {
  if (REGEX.parenthesis.test(text) ||
      REGEX.quotes.test(text)) {
    return true;
  }

  return false;
}

export default class SearchHelper {
  static getTermsFromText(text) {
    if (!text) {
      return null;
    }

    text = text.trim();
    if (_shouldKeepIntactTerm(text)) {
      return [ text ];
    }

    return _getSplitTerms(text);
  }
}
